import styled from "styled-components"

// Component
import ResetPasswordPage from "./ResetPasswordPage"

const StyledResetPasswordPage = styled(ResetPasswordPage)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  
  & .plate {
    padding: 35px;
    width: 415px;
    position: relative;
  }
`
export default StyledResetPasswordPage